import { gql } from 'react-apollo';
import { closeCreateReservationModal } from './modalActions';
import showToaster from '../../helpers/toasterMessages/showToaster';
import reservationsQuery from '../../components/siteadmin/ReservationManagement/reservationsQuery.graphql';

export const createComplimentaryReservationMutation = gql`
  mutation createComplimentaryReservation(
    $listId: Int!,
    $guestId: String!,
    $checkIn: String!,
    $checkOut: String!,
    $startTime: Float!,
    $endTime: Float!,
    $reservationNotes: String
  ) {
    createComplimentaryReservation(
      listId: $listId
      guestId: $guestId
      checkIn: $checkIn
      checkOut: $checkOut
      startTime: $startTime
      endTime: $endTime
      reservationNotes: $reservationNotes
    ) {
      id
      status
      errorMessage
      confirmationCode
    }
  }
`;

const createComplimentaryReservation = (values) => {
  return async (dispatch, getState, { client }) => {
    try {
      const listId = Number(values.listId);
      const startTime = Number(values.startTime);
      const endTime = Number(values.endTime);

      if (!listId || Number.isNaN(listId) || !values.guestId) {
        showToaster({
          messageId: 'complimentaryBookingError',
          toasterType: 'error',
          requestMessage: 'Please select a valid car and renter.',
        });
        return { status: 400 };
      }

      const { data } = await client.mutate({
        mutation: createComplimentaryReservationMutation,
        variables: {
          listId,
          guestId: values.guestId,
          checkIn: values.checkIn,
          checkOut: values.checkOut,
          startTime,
          endTime,
          reservationNotes: values.reservationNotes || null,
        },
        refetchQueries: [{
          query: reservationsQuery,
          variables: {
            currentPage: 1,
            searchList: '',
          },
        }],
      });

      if (data?.createComplimentaryReservation?.status === '200') {
        dispatch(closeCreateReservationModal());
        showToaster({
          messageId: 'complimentaryBookingSuccess',
          toasterType: 'success',
        });
        return {
          status: 200,
          id: data.createComplimentaryReservation.id,
        };
      }

      showToaster({
        messageId: 'complimentaryBookingError',
        toasterType: 'error',
        requestMessage: data?.createComplimentaryReservation?.errorMessage,
      });
      return {
        status: 400,
        errorMessage: data?.createComplimentaryReservation?.errorMessage,
      };
    } catch (error) {
      showToaster({
        messageId: 'complimentaryBookingError',
        toasterType: 'error',
        requestMessage: error?.message,
      });
      return {
        status: 400,
        errorMessage: error?.message,
      };
    }
  };
};

export default createComplimentaryReservation;
